import { Component, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { NgxTreeService } from '../ngx-tree-lib.service';
import { TreeModel, TreeConfig, TreeItemOptions } from '../models/tree-view.model';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'lib-ngx-tree-children',
  templateUrl: './ngx-tree-lib-children.component.html'
})
export class NgxTreeChildrenComponent implements AfterViewInit {
  showError: boolean;
  config: TreeConfig;
  language: string;
  element: TreeModel;
  draggable: boolean;
  itemOptions: TreeItemOptions;
  childrenArray: TreeModel[];
  renameForm;

  // get item from parent component
  @Input()
  set setItem(data: TreeModel) {
    this.element = data;
    this.itemOptions = {
      href: '#',
      hidden: false,
      hideChildren: false,
      position: this.treeService.getItemPosition(this.element),
      draggable: true,
      edit: false,
      showActionButtons: true,
      currentlyDragging: false,
      destenationTop: false,
      destenationBottom: false,
      disabled: false,
      showExpandButton: true,
      showDeleteButton: true
    };
    if (this.element.options) {
      this.setOptions(this.element.options);
      this.element.options = this.itemOptions;
    } else {
      this.element.options = this.itemOptions;
    }

    // enable subscribers
    this.enableSubscribers();
    // create form
    this.createForm();
  }

  constructor(private treeService: NgxTreeService, private fb: FormBuilder, private tr: TranslateService) {}

  // enable subscribe to config
  enableSubscribers() {
    this.treeService.config.subscribe(
      (config) => {
        if ( config !== null ) {
          this.config = config;
        } else {
          this.config = this.treeService.defaultConfig;
        }
        if (this.element.options.draggable) {
          this.element.options.draggable = this.config.enableDragging;
        }
      }
    );
    this.treeService.language.subscribe(
      (language) => {
        if ( language !== '' ) {
          this.language = language;
        } else {
          this.language = this.treeService.defaultLanguage;
        }
      }
    );
  }

  getTitleFromLocalized(strings: any): string {
    const empty: string = this.tr.instant('dashboard.empty');
    let res = empty;
    if (typeof strings === 'string' || typeof strings === 'number') {
      return strings.toString();
    }
    if (!Array.isArray(strings)) {
      return res;
    }
    strings.forEach(value => {
      if (value.language === this.language) {
        res = value.value;
      }
    });
    return res;
  }

  // set options to item
  setOptions(options) {
    for (const key of Object.keys(options)) {
      this.setValue(key, options);
    }
  }

  // set value to options keys
  setValue(item, options) {
    this.itemOptions[item] = options[item];
  }

  // create edit form
  createForm() {
    this.renameForm = this.fb.group({
      name: [this.element.name || '' , [
        Validators.required,
        Validators.minLength( this.config.minCharacterLength )
      ]],
    });
  }

  /*
    Event: onStartRenameItem;
    Enable rename mode in element
    Call onStartRenameItem() from tree service.
  */
  enableRenameMode(element) {
    element.options.edit = true;
    this.treeService.startRenameItem(element);
  }

  /*
    Event: onadditem;
    Generate id by new Date() by 'full year + day + time'.
    Call addNewItem() from tree service.
  */
  submitAdd(name, item ) {
      const d = `${new Date().getFullYear()}${new Date().getDay()}${new Date().getTime()}`;
      const elemId =  parseInt(d, null);
      this.treeService.addNewItem(elemId, name, item);
      this.element.options.hideChildren = false;
  }

  /*
    Event: onFinishRenameItem;
    Check is form valid.
    Call addNewItem() from tree service.
  */
  submitRename(item) {
    if (this.renameForm.valid) {
      this.showError = false;
      this.treeService.finishRenameItem(this.renameForm.value.name, item.id);
      this.element.options.edit = false;
    } else {
      this.showError = true;
    }
  }

  /*
    Events:
    onStartDeleteItem,
    onFinishDeleteItem,    
    onCancelDeleteItem.
    Check is item edit, then if name empty delete item.
    Call deleteItem() from tree service.
  */
  onSubmitDelete(item) {
    if (!this.element.options.edit) {
      this.treeService.deleteItem(item.id);
    } else {
      if ( item.name === null ) {
        this.treeService.deleteItem(item.id);
      } else {
        this.element.options.edit = false;
      }
    }
  }

  // after view init
  ngAfterViewInit() {}
}
